const sounds 	= require('@/components/general_parameters/sounds_default.js');
const axios 	= require('axios');
axios.defaults.withCredentials 	= 	false;

class Sounds{

	constructor(url){
		this.list_sounds = {};
		this.list 		 = [];
		this.url 		 = url;
		this.last_sound  = "";
		this.new_sound   = null;
		this.render([ ...sounds ]);
		this.isSoundActive = false;
		// console.log("render sounds")
		this.get_list();
	}
	getSoundByKey(key){
		if (key && this.list_sounds && this.list_sounds[key]) {
			return {...this.list_sounds[key]};
		}
	}

	getIsSoundActive(){
		return this.isSoundActive;
	}
	setIsSoundActive(state){
		this.isSoundActive = state;
	}

	render(items){
		// console.log(items," render sounds")
		if (items && items.length > 0) {
			items.forEach((sn, idx_sn)=>{
				if (sn && sn.name) {
					this.list_sounds[sn.name] 		=  { ...sn };
					let path = sn.url_path;
					if (sn.type == 'ext') {
						path = this.url + sn.url_path;
					}
					this.list_sounds[sn.name].audio = new Audio(path);
					// this.list_sounds[sn.name].audio.controls = true;
					// this.list_sounds[sn.name].audio.muted = true;
				}
			});
		}
		
	}

	play(key){
		if (key &&  this.list_sounds && this.list_sounds[key]){
			// if (this.list_sounds[key].audio.muted) { this.list_sounds[key].audio.muted = false}
			this.stop(this.last_sound);			
			this.list_sounds[key].audio.play();			
			this.last_sound = key;	
		}

	}

	stop(key){
		if (key &&  this.list_sounds && this.list_sounds[key]){			
			this.list_sounds[key].audio.currentTime = 0;
			this.list_sounds[key].audio.pause();
			this.list_sounds[key].audio.currentTime = 0;

		}
	}
	play_new_sound(path){
			// console.log("PLAY PATH ", path)
		if (path) {
			this.stop(this.last_sound);
			this.stop_new_sound();
			this.new_sound = new Audio(path);
			this.new_sound.play();			
		}

	}

	stop_new_sound(){
		if (this.new_sound) {
			
			this.new_sound.currentTime = 0;
			this.new_sound.pause();
			this.new_sound.currentTime = 0;
		}
	}

	get(key, list){
		
		if (list) {
			if (key == 'array') {
				// console.log("ARRAY Sounds ", this.list_sounds, Object.values(this.list_sounds))
				return [...Object.values(this.list_sounds)];
			}
			return { ...this.list_sounds };
		}else if (key &&  this.list_sounds && this.list_sounds[key]){
			return this.list_sounds[key];
		}
	}
	get_list(page = 1){
		const api 	 = this.url + "/api/v1/sounds/?page=" + page ;		 
		axios.get(api).then(res => {
			// console.log("RES sounds ", res);
			if (res && res.data) {
				let items = res.data;
				if (items.rows && items.rows.length > 0) {
					/*items.rows.forEach((item_row)=>{
						let temp_name = item_row.name.split('.').length > 0 ? item_row.name.split('.')[0] : item_row.name;
						item_row.name_sound = temp_name;					
						item_row.url_path = this.$URL + item_row.url_path;
						
					}); // forEach*/
					this.list = this.list.concat(items.rows);
					if (items.pages > page) {
						page++;
						this.get_list(page);
					}else{
						this.render(this.list);
					}
					

				}
			}
			/**/
		}).catch( er => {
			console.log("Error get LOGOS : ", er);
		})
	}

	update(key, item, opt){
		if(key && this.list_sounds && this.list_sounds[key]){
			
			if (item && !item.audio && item.url_path){
				item.audio  = new Audio(item.url_path);				
			}
			this.list_sounds[key] = item; 
		}
	}

	del(key, list){
		if (key && this.list_sounds &&  this.list_sounds[key]) {
			delete this.list_sounds[key];
		}
	}
}
export default  Sounds;